import { IBroadcastCommandPhotosViewerOption } from '@/interfaces';
import { broadcastService } from '..';

const CONSTS = {
  defaultOption: {
    images: [] as any
  } as IBroadcastCommandPhotosViewerOption
};

export const photoViewer = {

  show: (images: string[], payload?: Omit<IBroadcastCommandPhotosViewerOption, 'visible' | 'images'>) =>
    broadcastService
      .publish<IBroadcastCommandPhotosViewerOption>({
        type: 'photosViewer',
        payload: ({
          ...CONSTS.defaultOption,
          ...payload,
          bannerVisible: (payload?.bannerVisible ?? (images?.length ?? 0) > 1),
          images: images?.map(l => ({ src: l, key: l })) ?? [],
          onClose: e => {
            photoViewer.hide();
            payload?.onClose?.(e);
          },
          maskOpacity: 0.5,
          visible: true
        })
      }),

  hide: () =>
    broadcastService
      .publish<IBroadcastCommandPhotosViewerOption>({
        type: 'photosViewer',
        payload: ({
          ...CONSTS.defaultOption,
          visible: false
        })
      })

};
